import { render, staticRenderFns } from "./TopHeaderAdmin.vue?vue&type=template&id=c28a9580"
import script from "./TopHeaderAdmin.vue?vue&type=script&lang=js"
export * from "./TopHeaderAdmin.vue?vue&type=script&lang=js"
import style0 from "./TopHeaderAdmin.vue?vue&type=style&index=0&id=c28a9580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports